<template>
  <el-tabs type="border-card">
    <el-tab-pane label="企业资料">
      <shipmentAdd :parent-data="parentData" /> 
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import shipmentAdd from "./components/shipmentAdd.vue";
export default {
  name: "AddShipmentCompanyForm",
  components: { shipmentAdd },
  data() {
    return {
      parentData: {
        isCompany: true,
        areaOptions: this.$store.state.components.areaOptions
      }
    };
  },
	created() {
	}
};
</script>
